<template>

<div class="checkbox-wrapper">
    <label v-if="titlebefore" class="titlebefore">{{ titlebefore }}</label>
    <label v-html="label"></label>

      <div style="display:inline-block;padding-right:2em;"  v-for="value in selection" :key="value">
        <div class="flex">
          <input v-model="data" @change="validate" :value='value' :id="'i' + index + value" type="checkbox" />
          <label :for="'i' + index + value">{{ value }} </label>
        </div>
      </div>

    <div class="remarks">{{ remarks }}</div>
</div>

</template>

<script>
export default {

  data: function() {
          return  {
              data: this.currentvalues ? this.currentvalues : []
          }
  },

  props: ["value","label","selection","index","titlebefore","remarks","currentvalues"],

  model: {
    prop: "value",
    event: "update"
  },
    methods: {
      validate(){
        let app = this;
        this.$emit('update', app.data);
      }
    }

};
</script>
